export default "__VITE_ASSET__Dx4Bhx5U__"